<div id="homeslider" class="carousel slide pb-3 " data-ride="carousel" data-intervl="4000">
    <ol class="carousel-indicators home-carousel-indicators">
        <li data-target="#homeslider" data-slide-to="0" class="active"></li>
        <li data-target="#homeslider" data-slide-to="1"></li>
        <li data-target="#homeslider" data-slide-to="2"></li>
    </ol>

    <div class="carousel-inner top-carousel" role="listbox">
        <div class="carousel-item active">
            <!-- <img class=" top-img" src="/assets/images/mob-ban-1.jpg" alt="First slide"> -->
            <div>
                <div style="position: absolute;" class="caption container">
                    <!-- top-caption-left -->

                    <h1 class="head h1-responsive">WE'LL TAKE CARE OF YOU</h1>
                    <p class="carouselpara-left">Here at the Well Care family our passion is your care. We pride ourselves on providing a safe, friendly, and comfortable environment where our clients know that they are being well looked after whilst also providing top quality nursing
                        care to adhere to our client’s needs.
                    </p>
                    <a class="carouselpara-left" href="info@wellcareltd.co.uk">
                        <p class="homelink">info@wellcareltd.co.uk</p>
                    </a>

                    <div style="display: inline-flex" class="carouselpara-leftIcon">
                        <div class="imgIcon">

                            <a href="https://instagram.com/wellcare_official?igshid=efjs5ag0wx0v" target="_blank"> <img style="height: 100%; width: 100%;" src="../../../../../assets/images/img/intsa-icon.png" alt=""></a>
                        </div>
                        <div class="imgIcon space">
                            <!-- -->
                            <a href="https://www.facebook.com/Well-care-103900324936643 " target="_blank"><img style="height: 100%; width: 100%;" src="../../../../../assets/images/img/fb-icon.png" alt=""></a>
                        </div>
                        <div class="imgIcon space">
                            <a href="https://twitter.com/wellcareltd" target="_blank"> <img style="height: 100%; width: 100%;" src="../../../../../assets/images/img/twitter-icon.png" alt=""></a>
                        </div>
                        <div class="imgIcon space">

                            <a  href="https://api.whatsapp.com/send?phone=4407510698999" target="_blank"><img style="height: 100%; width: 100%;" src="../../../../../assets/images/img/whatsapp-icon.png" alt=""></a>
                        </div>

                    </div>

                </div>
            </div>

            <picture>
                <source srcset="/assets/images/img/homemobilebanner1.jpg" media="(max-width: 479px)">
                <source srcset="/assets/images/img/homebanner1.jpg" media="(max-width: 4000px)">
                <source srcset="/assets/images/img/homebanner1.jpg">
                <img src="/assets/images/img/homebanner1.jpg" alt="First slide" style="width:100%;">
            </picture>
            <div class="mask rgba-black-light"></div>



        </div>


        <div class="carousel-item">
            <!-- <img class=" top-img" src="/assets/images/mob-ban-1.jpg" alt="First slide"> -->

            <picture>
                <source srcset="/assets/images/img/wellcarehomemobilebanner2.jpg" media="(max-width: 479px)">
                <source srcset="/assets/images/img/wellcarehomebanner2.jpg" media="(max-width: 4000px)">
                <source srcset="/assets/images/img/wellcarehomebanner2.jpg">
                <img src="/assets/images/img/wellcarehomebanner2.jpg" alt="First slide" style="width:100%;">
            </picture>
            <div class="mask rgba-black-light"></div>



        </div>

        <div class="carousel-item">
            <!-- <img class=" top-img" src="/assets/images/mob-ban-1.jpg" alt="First slide"> -->

            <picture>
                <source srcset="/assets/images/img/wellcarehomemobilebanner3.jpg" media="(max-width: 479px)">
                <source srcset="/assets/images/img/wellcarehomebanner3.jpg" media="(max-width: 4000px)">
                <source srcset="/assets/images/img/wellcarehomebanner3.jpg">
                <img src="/assets/images/img/wellcarehomebanner3.jpg" alt="First slide" style="width:100%;">
            </picture>
            <div class="mask rgba-black-light"></div>



        </div>



        <a class="carousel-control-prev " href="#homeslider" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon top-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next " href="#homeslider" role="button" data-slide="next">
            <span class="carousel-control-next-icon top-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
</div>

<div class="top-container2">

    <div class="row-border d-flex flex-wrap flex-sm-wrap flex-md-nowrap flex-lg-nowrap">
        <div class="col-md-4 welcome">

            <div class="latesthead3">
                <h1>Welcome to Well Care</h1>
            </div>
            <div class="latestpara-aws">


                <p>
                    We specialise in nursing care and our agency spreads over Worcestershire, Herefordshire, and Gloucestershire. Our services include providing Nurses, Health Care assistants to Nursing and residential homes.

                </p>
                <button class="aws-read horse-bid1" routerLink="/services">Learn More
                </button>
            </div>

        </div>

        <div class="col-md-8 homimgcontainer">

            <img src="/assets/images/img/welcomewellcare.jpg" class=" img-responsive top-container2image ">

        </div>


    </div>
</div>

<div class="container care-container ">
    <div class="care-services">
        <h1>Well Care Services</h1>
    </div>
    <div class="row1  d-flex flex-wrap flex-sm-wrap flex-md-nowrap flex-lg-nowrap">


        <div class="card border-card">
            <img class="card-img-top " src="/assets/images/img/about.jpg" alt="Card image cap ">

            <div class="card-body ">
                <h5>About WellCare</h5>

                <p class="card-text "> We pride ourselves on providing a safe, friendly and comfortable environment and providing top quality nursing care to adhere to our client’s needs.

                </p>
                <a routerLink="/about" class="horse-bid1 ">Know more</a>
            </div>
        </div>

        <div class="card border-card">
            <img class="card-img-top " src="/assets/images/img/carestaff.jpg" alt="Card image cap ">

            <div class="card-body ">
                <h5>Caring Staff</h5>

                <p class="card-text ">Our team consists of highly experienced and trained staff able to provide exceptional care Services from care professionals you can fully trust..

                </p>
                <a routerLink="/about" class="horse-bid1 ">Know more</a>
            </div>
        </div>
        <div class="card border-card">
            <img class="card-img-top " src="/assets/images/img/homeservices.jpg" alt="Card image cap ">

            <div class="card-body ">
                <h5>Our Services</h5>

                <p class="card-text ">Our medical team is equipped with the best available professionals to satisfy all the short term and long term needs of our customers.

                </p>
                <a routerLink="/about" class="horse-bid1 ">Know more</a>
            </div>
        </div>
        <!-- <div class="card border-card">
            <div class="homeabtimg">
                <img class="card-img-top " src="/assets/images/img/carestaff.jpg" alt="Card image cap ">

            </div>

            <div class="card-body ">
                <h5>Caring Staff</h5>

                <p class="card-text ">Our team consists of highly experienced and trained staff able to provide exceptional care Services from care professionals you can fully trust..</p>
                <a routerLink="/services" class="horse-bid1 ">Know more</a>
            </div>
        </div>

        <div class="card border-card">
            <div class="homeabtimg">
                <img class="card-img-top " src="/assets/images/img/homeservices.jpg" alt="Card image cap ">
            </div>


            <div class="card-body ">
                <h5>Our Services</h5>

                <p class="card-text ">Our medical team is equipped with the best available professionals to satisfy all the short term and long term needs of our customers.

                </p>
                <a routerLink="/services" class="horse-bid1 ">Know more</a>
            </div>
        </div> -->

    </div>

</div>
<div class="whychoosecontainer">
    <div class="latestheadChoose">
        <h1>Why Choose Us</h1>
    </div>
    <div class="wpb">

        <div class="container wpbContainer col-md-6">

            <div class="wpb_wrapper">
                <div class="vc_row wpb_row section vc_row-fluid vc_inner  icon-small vc_custom_1516096645716 grid_section" style=" text-align:left;">
                    <div class=" section_inner clearfix botm">
                        <div class="section_inner_margin clearfix">

                            <div class="wpb_column vc_column_container vc_col-sm-12 vc_col-lg-6 vc_col-md-8">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper">
                                        <div class="q_icon_with_title tiny custom_icon_image ">
                                            <div class="icon_holder "><img itemprop="image" class="small-icons" src="/assets/images/img/icon-1.png" alt=""></div>
                                            <div class="icon_text_holder">
                                                <div class="icon_text_inner">
                                                    <h5 class="icon_title">Customer First </h5>
                                                    <p class="child">We expect and set the very best standards of care which our clients will be proud to receive. </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vc_empty_space" style="height: 12px"><span class="vc_empty_space_inner">
                                            <span class="empty_space_image"></span>
                                            </span>
                                        </div>

                                        <div class="q_icon_with_title tiny custom_icon_image ">
                                            <div class="icon_holder "><img itemprop="image" class="small-icons" src="/assets/images/img/icon-2.png" alt=""></div>
                                            <div class="icon_text_holder">
                                                <div class="icon_text_inner">
                                                    <h5 class="icon_title">Our Professionalism</h5>
                                                    <p class="child">Well Care is founded on transparency and honesty and everyone within the well Care family will embrace and uphold these values and professionalism.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vc_empty_space customheig"><span class="vc_empty_space_inner">
                                             <span class="empty_space_image"></span>
                                            </span>
                                        </div>

                                        <div class="q_icon_with_title tiny custom_icon_image ">
                                            <div class="icon_holder "><img itemprop="image" class="small-icons" src="/assets/images/img/icon-3.png" alt=""></div>
                                            <div class="icon_text_holder">
                                                <div class="icon_text_inner">
                                                    <h5 class="icon_title">24/7 Service</h5>
                                                    <p class="child">Highly qualified staff with years of expertise who can provide around the clock care for our clients</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vc_empty_space customheig"><span class="vc_empty_space_inner">
                                            <span class="empty_space_image"></span>
                                            </span>
                                        </div>

                                        <div class="q_icon_with_title tiny custom_icon_image ">
                                            <div class="icon_holder "><img itemprop="image" class="small-icons" src="/assets/images/img/icon-4.png" alt=""></div>
                                            <div class="icon_text_holder">
                                                <div class="icon_text_inner">
                                                    <h5 class="icon_title">Quality Assured </h5>
                                                    <p class="child">We are always looking to improve and strive for excellence based on the feedback that we continually receive from our clients </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="wpb_column vc_column_container vc_col-sm-6">
                                <div class="vc_column-inner">
                                    <div class="wpb_wrapper"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
        <div class="bigImgContainer">
            <img class="bigImg" src="/assets/images/img/why-choose-us.png" alt="">
        </div>
    </div>
</div>
<div class=" foto-big ">

    <div class="career">
        <h1 class="h1-responsive careerhead1 ">Want to join us?</h1>
        <div class="homunderline">
            <img src="/assets/images/img/underline-png.png" alt="">
        </div>
        <h1 class="h1-responsive careerhead2">With a 24 hour on-call service and availability of qualified and caring staff, we are in a position to make a difference to the care you are getting.</h1>
        <div>
            <!-- style="    text-align: -webkit-center;" -->
            <div>
                <!-- style="display: inline-flex;" -->
                <div class="hombutton">
                    <!-- style="    padding: 16px;" -->
                    <!-- <button class="horse-bidcareer" (click)="downloadPdf()">Application form</button> -->
                    <button class="horse-bidcareer"><a class="appForm" href="https://www.wellcareltd.uk/register.aspx" target="blank">Register </a></button>
                </div>
                <div class="hombutton">
                    <!-- style="    padding: 16px;" -->
                    <button class="horse-bidcareer" (click)="downloadTimesheet()">Timesheet</button>
                    <!-- style="    padding: 13px 32px;" -->
                </div>
            </div>
        </div>
        <br>
        <br>
        <br>

    </div>

    <div class="container alpha">


        <div class="sub_column module_column col-full sub_column_post_25 sub_column_9-0-0-0 tb_13a8299 last">
            <div class="tb-column-inner wrapping ">

                <!-- module icon -->
                <div class="module module-icon tb_qncz300  large circle icon_horizontal icon_position_center d-flex">
                    <div class="module-icon">
                        <div class="module-icon-itemLogo">
                            <img class="homeimg" src="/assets/images/img/WellCarelogogreen.png" alt="">
                        </div>
                    </div>
                </div>
                <!-- /module icon -->
                <!-- module icon -->
                <div class="module module-icon moduleCenter-icon  tb_ev8i300 d-flex large circle icon_horizontal icon_position_center ">
                    <div class="module-icon">
                        <div class="module-icon-item">
                            <p class="iconfooterhome">
                                <img class="homeimgsecond" src="/assets/images/img/phone-green-icon.png" alt="">
                                <a href="tel:+443337729507">03337729507</a>
                            </p>
                        </div>
                    </div>
                </div>
                <!-- /module icon -->
                <!-- module icon -->
                <div class="module module-icon moduleCenter-icon d-flex  tb_j0pr300  large circle icon_horizontal icon_position_center ">
                    <div class="module-icon">
                        <div class="module-icon-item">
                            <p class="iconfooterhome">
                                <img class="homeimgsecond" src="/assets/images/img/mail-green-icon.png" alt="">
                                <a href="mailto:info@wellcareltd.co.uk" target="_blank" style="display: text;">info@wellcareltd.co.uk</a>
                            </p>
                        </div>
                    </div>
                </div>
                <!-- /module icon -->
                <!-- module icon -->
                <div class="module module-icon moduleCenter-icon  tb_j0pr300 d-flex large circle icon_horizontal icon_position_center ">
                    <div class="module-icon">
                        <div class="module-icon-item botmitem">
                            <!-- <button  class="btnhome">   <a routerLink="/contact" class="btnhome">Contact Us</a></button> -->
                            <button class="btnhome" routerLink="/contact">CONTACT US</button>
                        </div>
                    </div>
                </div>
                <!-- /module icon -->
                <!-- /module buttons -->
            </div>
        </div>

    </div>
</div>